import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { RollingLoader, ToggleSwitch } from "../../../components/commons";
import { returnInputFieldLength } from "../../../utils/commonFunctions";

type AppProps = {
  showAddEditClientCategoryModal: boolean;
  isEdit: boolean;
  handleAddClientCategory: () => void;
  handleClientCategoryNameChange: (data: any) => void;
  toggleAddEditClientCategoryModal: () => void;
  clientCategoryName: string;
  clientCategoryNameError: string;
  handleToogleStatusChange: () => void;
  status: boolean;
  clientGroupUniqueCheckMessage:string;
  uniqueClientFetching:boolean;

};

const AddEditClientCategory = ({
  showAddEditClientCategoryModal,
  toggleAddEditClientCategoryModal,
  isEdit,
  clientCategoryName,
  clientCategoryNameError,
  handleAddClientCategory,
  handleClientCategoryNameChange,
  handleToogleStatusChange,
  uniqueClientFetching,
  clientGroupUniqueCheckMessage,


  status,
}: AppProps) => {
  return (
    <Modal
      isOpen={showAddEditClientCategoryModal}
      toggle={toggleAddEditClientCategoryModal}
    >
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} Client Category`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="form-group mt-3">
            <div>
              <label
                htmlFor="foldername"
                className={clientCategoryName ? "active" : ""}
              >
                Enter Client Category Name <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                <input
                  type="text"
                  className={`form-control ${
                    !!clientCategoryNameError ? "error-border" : null
                  }`}
                  name="text"
                  value={clientCategoryName}
                  autoFocus
                  onChange={(e) => handleClientCategoryNameChange(e)}
                  maxLength={60}
                  onKeyPress={(e: any) =>
                    e.key === "Enter" ? handleAddClientCategory() : null
                  }
                />
                 {uniqueClientFetching && <RollingLoader />}
              </div>
              {clientCategoryName?.trim().length && clientGroupUniqueCheckMessage?.includes("already exists") ?
                                <small className="text-danger">
                                    Category Name is already in use!
                                </small> : ""
                            }

              {!!clientCategoryNameError && (
                <small className="text-danger">{clientCategoryNameError}</small>
              )}
            </div>
            <span className="input-length">
              {returnInputFieldLength(clientCategoryName?.length, 60)}
            </span>
          </div>
          <div className="row">
            <div className="col-md-4 form-group mt-3">
              <label htmlFor=" Status" className="">
                Status
              </label>
              <ToggleSwitch
                handleToggleChange={() => handleToogleStatusChange()}
                isChecked={status}
              />
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddEditClientCategoryModal}>
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleAddClientCategory();
            toggleAddEditClientCategoryModal();
          }}
          disabled={clientCategoryName?.trim().length === 0 || clientGroupUniqueCheckMessage?.includes("already exists")}
        >
          {isEdit ? "Update Client Category" : "Add Client Category"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditClientCategory;
